<template>
  <div class="page-content">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <!-- customer information block -->
          <div class="page-content__header-description">
            Customer Information
          </div>
          <div class="row list-group">
            <div class="list-group-item">
              <dt class>Customer ID</dt>
              <dd class>{{ `${InstallationData.CID}` }}</dd>
            </div>
            <div class="list-group-item">
              <dt class>Full Name</dt>
              <dd class>
                {{
                  `${InstallationData.user.firstName} ${InstallationData.user.lastName}`
                }}
              </dd>
            </div>
            <div class="list-group-item">
              <dt class>Email Address</dt>
              <dd class>{{ `${InstallationData.user.email} ` }}</dd>
            </div>
            <div class="list-group-item">
              <dt class>Product Name</dt>
              <dd class>{{ ` ${InstallationData.deviceType.name}` }}</dd>
            </div>
          </div>
        </div>

        <div class="col-md-8">
          <!-- schedule installation block -->
          <div class="page-content__header-description">
            Schedule Installation
          </div>
          <div class="main-container">
            <form id="inventoryTransfer" @submit.prevent="submitRequest">
              <div class="row">
                <!-- <div role="tablist" class="col-md-12">
                  <div
                    v-for="(compSelect, index) in InstallationData.installationComponents"
                    :key="index"
                  >
                    <b-card no-body class="mb-1 statistic-widget statistic-widget-f">
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <a
                          class="order-collapse__header"
                          href="#"
                          v-b-toggle="'accordion_comp'+index"
                        >
                          <h5 style="text-transform: capitalize;">{{compSelect.componentItems.name}}</h5>
                          <b-badge variant="info" style="font-size: 1.5rem; color: #fff;">
                            Quantity: {{ compSelect.quantity }}
                            <b-badge
                              class="inset"
                              v-if="filterList(availableComponentsList,compSelect).length<compSelect.quantity"
                            >less than {{compSelect.quantity}} item in stock</b-badge>
                          </b-badge>
                        </a>
                      </b-card-header>
                      <b-collapse
                        :id="'accordion_comp'+index"
                        collapse
                        show
                        order-collapse-inner
                        visible
                        accordion="my-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-form-select
                            v-validate="required"
                            v-bind:name="compSelect.componentTypeId+'__'+i"
                            v-model="rows[tempData+'__'+compSelect.componentTypeId+'__'+i]"
                            v-for="i in compSelect.quantity"
                            :key="i"
                            :options="filterList(availableComponentsList,compSelect)"
                            v-bind:placehold="'Select '+tempData"
                            class="mb-3 componentType"
                            style="text-transform: capitalize !important"
                          ></b-form-select>
                          <span>{{ errors.first(compSelect.componentTypeId+'__'+i) }}</span>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </div>-->

                <div role="tablist" class="col-md-12">
                  <div>
                    <div class="card mb-1 statistic-widget statistic-widget-f">
                      <header role="tab" class="card-header p-1">
                        <a
                          href="#"
                          class="order-collapse__header"
                          aria-controls="accordion_comp0"
                          aria-expanded="true"
                          role="button"
                        >
                          <h5 style="text-transform: capitalize">
                            Select Installation Date
                          </h5>
                          <span
                            class="badge badge-info"
                            style="font-size: 1.2rem; color: rgb(255, 255, 255)"
                            >Installation Date Beginning From</span
                          >
                        </a>
                      </header>
                      <div
                        id="accordion_comp0"
                        class="collapse show"
                        collapse
                        show
                        order-collapse-inner
                        role="tabpanel"
                      >
                        <div class="card-body">
                          <!-- {{this.periods}} -->
                          <HotelDatePicker
                            format="DD-MM-YYYYTHH:MM:SS"
                            @check-in-changed="setCheckin"
                            @check-out-changed="setCheckOut"
                            :i18n="customFormat"
                          ></HotelDatePicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Modal for ADD button -->
                <el-form
                  class="form"
                  ref="form"
                  :model="packageForm"
                  label-width="120px"
                >
                  <vk-modal :show.sync="showAddModal">
                    <vk-modal-close
                      @click="showAddModal = false"
                    ></vk-modal-close>

                    <vk-modal-title>Add Component</vk-modal-title>
                    <!-- {{
                      packageForm
                    }}-->
                    <el-form-item class="form-item" label="Component">
                      <el-autocomplete
                        class="inline-input"
                        v-model="componentId"
                        :fetch-suggestions="querySearch"
                        placeholder="Please Input"
                        @select="handleSelect"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item class="form-item" label="Description">
                      <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="Description"
                        v-model="description"
                      ></el-input>
                    </el-form-item>
                    <el-form-item class="form-item" label="Quantity">
                      <el-input-number
                        v-model="packageForm.quantity"
                        :min="1"
                      ></el-input-number>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        class="customer-btn"
                        @click="onSubmit()"
                        >Add new item</el-button
                      >
                    </el-form-item>
                  </vk-modal>
                </el-form>

                <!-- BOQ Card -->
                <div class="col-md-12">
                  <el-card class="box-card">
                    <div slot="header" class="clearfix">
                      <span>Bill Of Quantity</span>
                      <el-button
                        style="float: right; padding: 3px 0"
                        type="text"
                        @click="showAddModal = true"
                        >Add Component</el-button
                      >
                    </div>
                    <div
                      v-for="(data, index) in packageData"
                      :key="index"
                      class="text item"
                      style="display: flex; justify-content: space-between"
                    >
                      <span>
                        <h5>{{ data.componentItems.name }}</h5>
                      </span>
                      <span>
                        <el-input-number
                          id="packageQty"
                          v-model="data.quantity"
                          :min="1"
                        ></el-input-number>
                      </span>
                      <!-- <h4>{{_package['quantity']}}</h4> -->
                    </div>
                  </el-card>
                </div>

                <div class="p-trial-period-expired__upgrade col-md-12">
                  <div class="form-group">
                    <button class="btn btn-secondary btn-lg" type="submit">
                      Submit installation schedule
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {
  Card,
  Form,
  FormItem,
  Autocomplete,
  // ...
} from "element-ui";
// import Autocomplete from "../../utils/Autocomplete";
import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";
import { mapGetters, mapActions } from "vuex";
import HotelDatePicker from "vue-hotel-datepicker";
import moment from "moment";
// import { Datetime } from "vue-datetime";
// import "vue-datetime/dist/vue-datetime.css";

export default {
  components: {
    // Autocomplete,
    HotelDatePicker,
    "el-card": Card,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-autocomplete": Autocomplete,
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  data() {
    return {
      componentData: [],
      packageData: [],
      BOQ: [],
      // displayData: [],
      componentId: "",
      showAddModal: false,
      description: " ",
      deviceName: [],
      packageForm: {
        componentId: null,

        // componentName: null,
        // deviceTypeId: null,
        quantity: null,
      },
      customFormat: {
        night: "Day",
        nights: "Days",
        "day-names": ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
        "month-names": [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        "check-in": "Installation starts",
        "check-out": "Installation ends",
      },
      requestId: this.$route.params.Installation,
      InstallationData: {},
      componentsToUse_public: {},
      availableComponentsList: [],
      tmp: [],
      rows: [],
      results: {},
      inventories: null,
      periods: {
        from: null,
        to: null,
      },
      tempData: "",
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession",
    ]),
    componentsToUse: {
      // getter
      get: function () {
        return this.componentsToUse_public;
      },
      // setter
      set: function (newValue) {
        this.componentsToUse_public = newValue;
      },
    },
  },
  methods: {
    handleSelect(item) {
      // console.log(item.id);
      this.packageForm.componentId = item.id;
    },
    querySearch(queryString, cb) {
      var _data = this.componentData;
      var results = queryString
        ? _data.filter((single) => this.createFilter(queryString, single))
        : _data;
      cb(results);
    },
    createFilter(queryString, single_item) {
      // console.log(single_item.name);
      return (
        single_item.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1
      );
    },
    getComponents() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get("/components/", {}).then((components) => {
        //console.log(JSON.stringify(components.data))
        container.componentData = components.data.map((x) => ({
          ...x,
          value: x.name,
        }));
        console.log(container.componentData);
        var data = [];
        for (var i = 0; i < container.componentData.length; i++) {
          // text += cars[i] + "<br>";
          this.deviceName.push({
            id: container.componentData[i].id,
            name: container.componentData[i].name,
          });
          // return data
        }
        console.log(this.deviceName);

        // container.setAccessLocal(saveRole.join);
      });
    },

    onSubmit() {
      // console.log(this.packageForm)
      var addedDevice = this.packageData.filter(
        (x) => x.componentTypeId === this.packageForm.componentId
      );
      // addedDevice[0].componentItems.description = this.description;
      // console.log(addedDevice);
      // console.log(addedDevice.length);
      if (addedDevice.length > 0) {
        this.packageData.forEach((x) => {
          // Snippet in IF statement checks for repeated component type
          if (x.componentTypeId === this.packageForm.componentId) {
            x.componentItems.name.replace(addedDevice[0].name);
            x.quantity = addedDevice[0].quantity;
            addedDevice[0].componentItems.description = this.description;
            // this.showInfoMsg({
            //   message: "Component Added!"
            // });
            this.showAddModal = false;
            console.log(x.componentItems.name.replace(addedDevice[0].name));
            console.log((x.quantity = this.packageForm.quantity));
            // } else {
            //     this.deviceName.forEach(y => {
            //       addedDevice[0].name = y.name;
            //       console.log(this.packageData.push(addedDevice));

            //     })
          }
        });
      } else {
        var test = this.deviceName.filter(
          (x) => x.id === this.packageForm.componentId
        );
        // console.log("test");
        // addedDevice[0].componentItems.description = this.description;
        console.log(test);
        // console.log(this.$route.params);
        if (test.length > 0) {
          var otherComponents = {
            quantity: this.packageForm.quantity,
            createdAt: "2020-01-06T10:44:45.528Z",
            updatedAt: "2020-01-06T10:44:45.528Z",
            componentTypeId: this.packageForm.componentId,
            deviceRequestId: this.$route.params.Installation,
            componentItems: {
              name: test[0].name,
              description: this.description,
              createdAt: "2020-01-06T10:44:45.528Z",
              updatedAt: "2020-01-06T10:44:45.528Z",
              id: this.packageForm.componentId,
            },
          };
          let tmp = [];
          // this.packageData.push(otherComponents);
          tmp = [...this.packageData, otherComponents];

          // Snippet in IF statement checks for repeated component type
          if (test.id === this.packageForm.componentId) {
            tmp.forEach((x) => {
              tmp.componentItems.name = test[0].name;
              tmp.quantity = this.packageForm.quantity;
            });
          } else {
            // Code below pushes in new component into the BOQ
            console.log(tmp);
            this.packageData = tmp;

            this.BOQ = tmp;

            // console.log(this.packageData);
            // console.log(this.BOQ); // Bill of Quantity Data
            // console.log(otherComponents);
          }
          // tmp.forEach(x => {
          //   if(x.componentTypeId === this.packageForm.componentId){
          //     tmp.componentItems.name = test[0].name;
          //     tmp.quantity = this.packageForm.quantity;
          //   }
          // })
        }
        this.showAddModal = false;
      }
    },

    setCheckin(chkInDate) {
      this.periods.from = chkInDate;
      console.log(this.periods.from);
    },
    setCheckOut(chkOutnDate) {
      this.periods.to = chkOutnDate;
      console.log(this.periods.to);
    },
    filterList(arrayVal, component) {
      // console.log(arrayVal);
      const dat = arrayVal.filter((x) => {
        return x.componentId === component.componentTypeId;
      });
      dat.unshift({
        value: null,
        disabled: true,
        text: "Please Select " + component.componentItems.name,
      });
      return dat;
    },
    validateRequestForm(entries) {
      let qty = 0;
      this.InstallationData.installationComponents.forEach((a) => {
        qty += a.quantity;
      });
      for (let [field, value] of Object.entries(this.periods)) {
        if (value === null || value === "") {
          return "Please fill all fields!";
        }
      }
      return qty > Object.keys(entries).length
        ? "Please fill all entries !!!"
        : false;
    },
    duplicateEntries(param) {
      const names = Object.values(param);
      const count = (names) =>
        names.reduce((a, b) => Object.assign(a, { [b]: (a[b] || 0) + 1 }), {});
      const duplicates = (dict) => Object.keys(dict).filter((a) => dict[a] > 1);
      let c = count(names);
      let d = duplicates(count(names));
      return d.length > 0 ? d : false;
    },
    compareDate(date1, date2) {
      if (date1 == null || date2 == null) {
        return "Please select date";
      }
      let now = moment().startOf("day");
      let myDate = date1.getTime();
      let myDate2 = date2.getTime();

      console.log({
        now,
        myDate,
        myDate2,
      });

      return now > myDate
        ? "Invalid/Past Date"
        : myDate > myDate2
        ? "Invalid Date supplied"
        : false;
    },
    submitRequest(event) {
      event.preventDefault();
      const HTTP = this.$httpUtils.instance;
      const container = this;
      let inverters = "";
      var chk = this.compareDate(this.periods.from, this.periods.to);
      if (chk !== false) {
        this.showErrorMsg({
          message: chk.toString(),
        });
        return;
      } else {
        let scope = {
          solarKitIds: "--",
          name: this.InstallationData["installationName"]
            ? `${this.InstallationData["installationName"]} `
            : `${this.InstallationData.user["firstName"]} ${this.InstallationData.user["lastName"]}`,
          // `${this.InstallationData.user.firstName}  ${this.InstallationData.user.lastName}`,
          status: "requested",
          CID: this.InstallationData.CID,
          userId: this.InstallationData.user.id,
          deviceTypeId: this.InstallationData.deviceType.id,
          sector: this.InstallationData.sector
            ? this.InstallationData.sector
            : null,
          to: this.periods.to,
          from: this.periods.from,
          deviceRequestId: this.requestId * 1,
          BOQ: JSON.stringify(this.BOQ),
        };
        console.log({ scope });
        console.log({ InstallationData: this.InstallationData });
        let drq = this.InstallationData;
        delete drq.user;
        delete drq.deviceType;
        delete drq.installationComponents;
        drq.status = 3;

        HTTP.put(`/device_requests/${this.requestId}`, drq)
          .then((response) => {
            HTTP.post("/installations", scope).then((response) => {
              const Response = response.data;
              if (Response) {
                container.showSuccessMsg({
                  message:
                    "Installation successfully scheduled & inventory requested",
                });
                container.$router.push({
                  name: "devices",
                  params: {
                    activetab: "inventory_request",
                  },
                });
              }
            });
          })
          .catch((error) => {
            console.log({ error });
            this.showErrorMsg({
              message: "error occured",
            });
          });
      }

      // chk = this.validateRequestForm(this.rows);
      // if (chk !== false) {
      //   this.showErrorMsg({
      //     message: chk
      //   });
      //   return;
      // }
      // chk = this.duplicateEntries(this.rows);
      // if (chk !== false) {
      //   this.showErrorMsg({
      //     message: "Duplicate entries for " + chk.toString()
      //   });
      //   return;
      // }

      // for (var key in this.rows) {
      //   if (key.toLowerCase().indexOf("inverter") > -1)
      //     inverters += `${this.rows[key]} `;
      // }
    },
    availableComponents() {
      const HTTP = this.$httpUtils.instance;
      const context = this;
      const url = `/inventories/?filter={"limit": "1000", "where": {"status": "0"}}`;
      HTTP.get(url)
        .then((response) => {
          null;
          const componentList = response.data;
          console.log(componentList);
          componentList.filter((x) => {
            x.value = x.serialNumber;
            x.text = x.serialNumber;
          });
          context.availableComponentsList = componentList;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    formatTime(date) {
      var date = new Date(date); //or your date here
      return `${date.getHours()} : ${date.getMinutes()} :  ${date.getSeconds()}`;
    },
    formatDate(date) {
      var date = new Date(date); //or your date here
      return `${date.getFullYear()} / ${
        date.getMonth() + 1
      }  /  ${date.getDate()}`;
    },
    componentName(id) {
      console.log(this.componentsToUse);
      // this.tempData = this.componentsToUse.find(x => x.id == id)[
      //   "component"
      // ]["name"];
      // return this.tempData;
    },
    componentTypeNames() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get(
        `/component_types/?filter={"include": {"relation": "component","scope": {"where": {"id": "componentId" }}}}`,
        {}
      ).then((rolesdata) => {
        container.componentsToUse = rolesdata.data;
        // console.log(container.componentsToUse);
      });
    },
    getInstallationData() {
      const HTTP = this.$httpUtils.instance;
      HTTP.get(
        `/device_requests/${this.requestId}?filter={"include": ["user","deviceType",{"installationComponents":["componentItems"]}]}`
      ).then((resp) => {
        // console.log(resp.data.installationComponents);
        this.InstallationData = resp.data;
        this.packageData = resp.data.installationComponents.map((x) => {
          x.description = x.componentItems.description;
          return x;
        });
        this.tmp = resp.data.installationComponents;
        this.packageQuantity = this.packageData.quantity;
        this.BOQ = this.packageData;
        console.log({ po: this.packageData });
      });
    },
  },

  mounted() {
    this.componentTypeNames();
    this.availableComponents();
    this.getInstallationData();
    // this.fetchSysTypes();
    this.getComponents();
  },
};
</script>

<style>
.section-container {
  border-radius: 7px;
  background: #fff;
  -webkit-box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  margin-bottom: 1.875rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  min-height: 200px;
}

.p-trial-period-expired__upgrade {
  /* margin-left: 1.9rem; */
}

.p-trial-period-expired__upgrade .form-group {
  width: 100%;
}

.custom-control-description {
  margin-left: 12px;
}

#__BVID__36___BV_label_,
#__BVID__40___BV_label_ {
  font-size: 13px !important;
}

.card-header {
  padding: 0;
}

.statistic-widget-f {
  border-bottom: 1px solid #f4f4f4;
  padding: 1rem 1.9rem;
}

.test-basic__format span {
  font-weight: 800;
  color: #269af1;
}
.badge.inset {
  font-size: 8px;
  text-transform: lowercase;
  background: inherit;
  color: white;
  padding: 0;
  margin-left: 2px;
}

.badge.inset:before {
  content: "( ";
}

.badge.inset:after {
  content: " )";
}

.badge-info {
  background-color: #f6bb42;
  text-transform: lowercase;
  font-size: 8px !important;
  border-radius: 30px;
}

.badge {
  min-width: auto;
}

.order-collapse__header h5 {
  font-weight: bold;
  color: #111111;
}

.card-body {
  margin-bottom: 20px;
}

.order-collapse__header {
  padding: 1rem 0 1rem 0;
}

.componentType {
  margin: 1rem 0 1rem 0;
}

.list-group-item {
  padding: 1.5rem 2rem;
}

dd {
  color: #999999;
}

/* .dateInput {
  margin-left: 12px;
  border: 1px solid rgba(211, 217, 221, 0.6);
} */

/** datepicker styles **/
/* .datepicker__dummy-wrapper--is-active{
  border: 1px solid #1a93ca !important;
}

.datepicker__month-day--selected{
  background-color: rgba(26, 147, 202, 0.66);
} */

.datepicker__input:focus {
  outline: none;
  color: #00ca9d !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/instalation/instalationSchedule.vue